import { computed } from 'vue'
import { useConfigStore } from '@/stores/config'

export function useNavigationLinks() {
  const configStore = useConfigStore()

  const navigationLinks = computed(() => {
    const links = configStore.getReferenceValues('NavigationLinks')
    return Array.isArray(links) ? links : []
  })

  const useNavLink = (key) => {
    const linkItem = computed(() => navigationLinks.value.find((link) => link.value === key))

    return {
      /**
       * @deprecated Use the `label` property instead.
       */
      link: computed(() => linkItem.value?.altDescription || ''),
      /**
       * @deprecated Use the `url` property instead.
       */
      title: computed(() => linkItem.value?.title || ''),
      label: computed(() => linkItem.value?.altDescription || ''),
      url: computed(() => linkItem.value?.title || ''),
    }
  }

  return { useNavLink }
}
